import { useContext, useEffect } from 'react';

// services
import { me } from '../../../services/login/login.service';
import UsuarioContext from "../../../../context/userContext/context";
import { createFavoriteBulk } from '../../../services/create-account/create-account.service';
import { bulkStorageFavoriteMaterials } from '../../../utils/storageFavoriteMaterials';

export const SSOLogin = (): JSX.Element => {
  const { user, update } = useContext(UsuarioContext);

  const queryParams = new URLSearchParams(window.location.search);
	const authToken = queryParams.get("token");

  useEffect(() => {
    if (!authToken) {
      return;
    }

    update({ ...user, token: authToken });
    me().then((res) => {
      update({
        ...user,
        token: authToken,
        id: res.id,
        name: res.name,
        email: res.email,
        company: res.company,
        job: res.job,
        phone: res.phone,
        picture: res.picture,
        username: res.username,
        is_active: res.is_active,
        is_staff: res.is_staff,
        is_superuser: res.is_superuser,
        is_whatsapp: res.is_whatsapp,
        is_signature: res.is_signature,
        profile_status: res.profile_status
      });

      const favorites = bulkStorageFavoriteMaterials()

      createFavoriteBulk(favorites).then(() => {
        window.location.href = "/home";
      })

    })
  }, []);

  return (
    <></>
  )
}
